import configDefault, { IConfig } from './ConfigDefault';

/**
 * 测试服配置
 */
const configData: IConfig = {
	...configDefault,
	/**
	 * 显示日志
	 *
	 * @type {boolean}
	 * @memberof ConfigDefault
	 */
	isDisplayLogs: true,

	/** 代理配置 */
	proxyTable: {
		'/umaterial': {
			target: 'http://test2.umaterial.oa.com'
		},
		'/ubuy': {
			target: 'http://test2.ubuy.oa.com'
		},
		'/pages': {
			target: 'http://test2.ubuy.oa.com'
		},
		'/logout': {
			target: 'http://test2.ubuy.oa.com'
		},
		'/login': {
			target: 'http://test2.ubuy.oa.com'
		},

		// bfc
		'/order': {
			target: 'http://dev.bfc-order.woa.com',
			changeOrigin: true
		},
		'/material': {
			target: 'http://dev.bfc-material.woa.com',
			changeOrigin: true
		}
	}
};

export default configData;
